module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraBoldItalic.e12f6223.ttf";